// extracted by mini-css-extract-plugin
export var mobile = "Header-module--mobile--m3S67";